import { RoleService } from "@js/services/RoleService";
import {
  BrickflowEventLogClient,
  Case,
  CaseClient,
  CaseCrudClient,
  CaseLender,
  CaseLenderClient,
  CaseLenderStateEnum,
  EventLogEnum,
  LenderClient,
  Organisation,
  OrganisationClient,
  ProductTypeEnum,
  UserClient,
  ApplicationUserCrudClient,
} from "@src/apis/ModularClient";
import { CaseService } from "@js/services/CaseService";
import CaseLenderHelper from "@js/helpers/CaseLenderService";
import { UserService } from "@js/services/UserService";
import { Expand } from "@ccq/ts-lib";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class CaseLenderController {
  static $inject = [
    "$routeParams",
    "$location",
    "CaseClient",
    "CaseService",
    "LenderClient",
    "CaseLenderClient",
    "RoleService",
    "UserService",
    "UserClient",
    "OrganisationClient",
    "BrickflowEventLogClient",
    "$sce",
    "CaseCrudClient",
    "ODataHelper",
    "ApplicationUserCrudClient",
  ];

  // have todays date
  todaysDate: Date = new Date();
  //To save url for Lender Logo Image
  lenderLogos: string[] = [];
  //To save the Lender Id and request Lender URL
  lenderId: number[] = [];
  // Controls showing the data loading "spinner"
  dataLoading: boolean = false;
  //Show lender names or Lender Generic Name
  showLenders: boolean = false;

  //get development Input Id
  developmentInputId: number;

  currentCase: Expand<Case, { readonly developmentInput: true }>;
  caseLenders: CaseLender[];
  // The lender the user has clicked apply/heads of terms/feedback for
  selectedCaseLender: CaseLender;
  // Controls showing the Application Terms and Conditions modal
  showApplyTsAndCs: boolean = false;
  // Controls showing the Preferred Lenders modal
  showPreferredPackagers: boolean = false;
  // Controls showing the application confirmation message
  showApplicationConfirmation: boolean = false;
  // Show the feedback modal
  showFeedbackModal: boolean = false;
  // Show the Information modal
  showInformationMessage: boolean = false;
  // show the button to confirm deleting the case lender
  showConfirmDeleteButton: boolean = false;
  // case to remove
  caseLender: CaseLender;
  // indicates whether a bid has been accepted on the case
  hasBidAccepted: boolean = false;

  // Message to be displayed in the message modal
  messageContent: string;

  showProceedModal: boolean = false;

  IsSupplimentInfoFilled: boolean = false;

  currentLenderPreferredBrokers: Organisation[];
  currentLenderPreferredPackagersText: string;
  hasLenderPreferredBrokers: boolean = false;
  emailCache = {};

  //Export Modal
  selectedLenders: { [lenderId: number]: boolean } = {};
  showExport: boolean = false;
  showExportButton: boolean = false;
  seeLenderNames: boolean = false;
  showLenderNames: boolean = true;

  currentUserOrg: Organisation;

  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private $location: ng.ILocationService,
    private caseClient: CaseClient,
    private caseService: CaseService,
    private lenderClient: LenderClient,
    private caseLenderClient: CaseLenderClient,
    private roleService: RoleService,
    private userService: UserService,
    private userClient: UserClient,
    private organisationClient: OrganisationClient,
    private eventLogClient: BrickflowEventLogClient,
    private $sce: ng.ISCEService,
    private caseCrudClient: CaseCrudClient,
    private odataHelper: ODataHelper,
    private applicationUserCrudClient: ApplicationUserCrudClient,
  ) {
    if (this.$routeParams.CaseId) {
      this.dataLoading = true;

      this.odataHelper
        .getOne(this.caseCrudClient, {
          filter: {
            id: {
              eq: Number(this.$routeParams.CaseId),
            },
          },
          expand: {
            developmentInput: true,
          },
        })
        .then((response) => {
          this.currentCase = response;
          this.developmentInputId = response.developmentInputId;
          this.lenderDisplayName(this.developmentInputId);
          this.userService.GetDefaultBrokerOrganisation().then((result) => {
            this.currentUserOrg = result;
            this.seeLenderNames = result?.showLenderNames;
            this.caseLenderClient.fetchByCaseId(this.$routeParams.CaseId, this.seeLenderNames).then((response) => {
              this.caseLenders = response;

              for (var i = 0; i < this.caseLenders.length; i++) {
                this.lenderId[i] = this.caseLenders[i].lenderId;
                this.toggleLender(this.caseLenders[i]);
              }
              /*this.getAllLenderLogos(this.lenderId);*/

              var bidAccepted = this.caseLenders.find((x) => x.isBidAccepted == true);

              if (bidAccepted) {
                this.hasBidAccepted = true;
              }
              this.dipRecieved();
            });
          });
          this.IsSupplimentInfoFilled = this.caseService.getIsSupplimentInfoFilled();
        })
        .finally(() => {
          this.dataLoading = false;
        });
    }
  }

  ////Get URL for the specific lender
  //getLenderLogos(index: number) {
  //    return this.lenderLogos[index];
  //}

  //// Get all URL for all Lender result
  //getAllLenderLogos(lenderId: number[]) {
  //    this.lenderClient.getAllLenderLogos(lenderId).then(result => {
  //        this.lenderLogos = result;

  //    })
  //}

  /** Redirects to the case dashboard */
  goToCaseDashboard() {
    this.$location.path("/casedashboard/" + this.currentCase.id);
  }

  /** Redirects to the user dashboard */
  goToUserDashboard() {
    this.userService.clearSelectedNavMenuAndFilterStorageData();
    this.$location.path("/userdashboard");
  }

  /** Process the Heads of Terms button being clicked */
  headsOfTermsClicked(selectedCaseLender: CaseLender, index) {
    this.selectedCaseLender = selectedCaseLender;
    this.$location.path("/headsofterm/" + this.currentCase.id + "/" + this.selectedCaseLender.id);
  }
  /**
   * Process the feedback button being clicked
   * @param selectedCaseLender The lender associated with the button's row
   */
  feedbackButtonClicked(selectedCaseLender: CaseLender) {
    this.selectedCaseLender = selectedCaseLender;

    // Show the Feedback Modal
    this.showFeedbackModal = true;
  }

  lenderDisplayName(developmentInputId) {
    this.organisationClient.showLenderNamesAndLogos(developmentInputId, false).then((result) => {
      this.showLenders = result;
    });
  }

  /**Process the Submit Terms and Conditions button being clicked */
  submitTsAndCsClicked() {
    this.showApplyTsAndCs = false;
    this.selectedCaseLender.isBidAccepted = true;

    this.caseLenderClient
      .addUpdate(this.selectedCaseLender)
      .then((response) => {
        this.selectedCaseLender.isBidAccepted = response.isBidAccepted;
        this.hasBidAccepted = response.isBidAccepted;

        return this.caseLenderClient.applyToLender(
          this.selectedCaseLender.caseId,
          this.selectedCaseLender.id,
          this.hasLenderPreferredBrokers,
        );
      })
      .then((response) => {
        this.selectedCaseLender.caseLenderState = response.caseLenderState;
        this.caseLenders = this.caseLenders.map((cl) =>
          cl.id !== this.selectedCaseLender.id ? cl : this.selectedCaseLender,
        );
      })
      .finally(() => {
        this.messageContent = "Thank you for submitting an application with this lender.";
        if (this.hasLenderPreferredBrokers) {
          this.showPreferredPackagers = true;
        } else {
          this.showInformationMessage = true;
        }
      });
  }

  /**
   * Process the Apply button being clicked
   */
  submit(lender: CaseLender) {
    this.selectedCaseLender = lender;

    this.lenderClient
      .getSelectedLenderPreferredOrgs(this.selectedCaseLender.lenderId)
      .then((response) => {
        this.currentLenderPreferredBrokers = response;

        return this.userService.getBrokerOrganisationId();
      })
      .then((response) => {
        //checks if broker that applies is not part of the preferred brokers list

        this.hasLenderPreferredBrokers =
          this.currentLenderPreferredBrokers != null &&
          this.currentLenderPreferredBrokers.length > 0 &&
          !this.currentLenderPreferredBrokers.some((org) => org.id === response);

        if (this.hasLenderPreferredBrokers) {
          this.currentLenderPreferredBrokers.forEach((org) => {
            this.getBrokerAdminEmail(org);
          });
        }

        return this.lenderClient.getLenderPreferredPackagersText(this.selectedCaseLender.lenderId);
      })
      .then((response) => {
        this.currentLenderPreferredPackagersText = response;
      })
      .finally(() => {
        this.showApplyTsAndCs = true;
      });
  }

  /**
   * Process the Send Feedback button being clicked
   * @param message
   */
  sendFeedbackClicked() {
    this.caseLenderClient
      .sendFeedbackToLender(this.selectedCaseLender)
      .then((response) => {
        this.messageContent = "Your feedback has been sent to the lender.";
        this.showInformationMessage = true;
      })
      .catch((error) => {
        this.messageContent = "Sorry, something went wrong while sending feedback to lender. Please try again.";
      })
      .finally(() => {
        this.showFeedbackModal = false;
      });
  }

  /**
   * Process the Apply button being clicked
   * @param currentCaseLender
   */
  applyClicked(selectedCaseLender: CaseLender) {
    this.selectedCaseLender = selectedCaseLender;

    // Show the Terms and Conditions modal
    this.showApplyTsAndCs = true;
  }
  /**
   * Process the Cancel Application button being clicked
   * @param currentCaseLender
   */

  cancelTerms(selectedCaseLender: CaseLender) {
    this.caseLenderClient
      .getSelectedCaseLender(selectedCaseLender.id, this.seeLenderNames)
      .then((response) => {
        this.selectedCaseLender = response;
      })
      .then(() => {
        if (this.selectedCaseLender.caseLenderState == CaseLenderStateEnum.Applied) {
          this.selectedCaseLender.isBidAccepted = false;
          this.caseLenderClient
            .addUpdate(this.selectedCaseLender)
            .then((response) => {
              this.selectedCaseLender.isBidAccepted = response.isBidAccepted;
              this.hasBidAccepted = response.isBidAccepted;

              return this.caseLenderClient.cancelApplication(
                this.selectedCaseLender.caseId,
                this.selectedCaseLender.id,
              );
            })
            .then((response) => {
              this.selectedCaseLender.caseLenderState = response.caseLenderState;
              this.caseLenders = this.caseLenders.map((cl) =>
                cl.id !== this.selectedCaseLender.id ? cl : this.selectedCaseLender,
              );
            })
            .finally(() => {
              this.messageContent = "Application with this lender has been cancelled.";
              this.showInformationMessage = true;
            });
        } else {
          this.messageContent = "There was a problem with cancelling this application. Please refresh and try again.";
          this.showInformationMessage = true;
        }
      });

    //this.showProceedModal = true;
  }

  getStatusText(selectedCaseLender: CaseLender): string {
    var statusText = "";

    if (this.roleService.IsLender) {
      statusText = CaseLenderHelper.getStatusTextForLender(
        selectedCaseLender.caseLenderState,
        selectedCaseLender.isBidAccepted,
      );
    } else {
      switch (selectedCaseLender.caseLenderState) {
        case CaseLenderStateEnum.Offered: {
          if (this.hasBidAccepted) {
            statusText = selectedCaseLender.isBidAccepted
              ? "DIP received and accepted"
              : "DIP received but applying to another lender";
          } else {
            statusText = "DIP received";
          }
          break;
        }
        case CaseLenderStateEnum.Received: {
          statusText = "Awaiting DIP";
          if (this.hasBidAccepted) {
            statusText = "Awaiting DIP but applying to another lender";
          } else {
            statusText = "Awaiting DIP";
          }
          break;
        }
        case CaseLenderStateEnum.Cancelled: {
          if (this.hasBidAccepted) {
            statusText = "Application cancelled but applying to another lender";
          } else {
            statusText = "Application cancelled";
          }
          break;
        }
      }
    }

    return statusText;
  }

  editApplicationDetails() {
    this.$location.path("/applicationdetails/" + this.currentCase.id);
  }

  deleteButton(caseLender: CaseLender) {
    this.showConfirmDeleteButton = true;
    this.showInformationMessage = true;
    this.messageContent = "Are you sure you want to remove " + caseLender.lenderName + "?";
    this.caseLender = caseLender;
  }

  delete() {
    this.caseLenderClient
      .markAsDeleted(this.caseLender.id)
      .then((result) => {
        this.caseLenders = this.caseLenders.filter((x) => x.id != this.caseLender.id);
      })
      .finally(() => {
        this.showInformationMessage = false;
        delete this.caseLender;
        this.showConfirmDeleteButton = false;
      });
  }

  /**
   * Determines whether to show the Shortlist More Lenders button.
   * Should be shown if there are less than 3 "active" shortlisted lenders i.e. haven't rejected/withdrawn
   * and no DIP is accepted
   * */
  showShortlistMoreLendersButton(): boolean {
    var showButton: boolean = false;
    if (this.caseLenders) {
      var activeShortlistCount = this.caseLenders.filter(
        (lender) =>
          lender.caseLenderState != CaseLenderStateEnum.Withdrawn &&
          lender.caseLenderState != CaseLenderStateEnum.Rejected,
      ).length;

      showButton = activeShortlistCount < 5 ? true : false;
    }

    //Hide button if DIP accepted
    if (this.hasBidAccepted) {
      showButton = false;
    }

    return showButton;
  }

  shortlistMoreLenders() {
    this.$location.path("/shortlistmore/" + this.currentCase.developmentInputId + "/" + this.currentCase.id);
  }

  toggleLender(lender: CaseLender) {
    this.selectedLenders[lender.id] = !this.selectedLenders[lender.id];
  }

  stateFilter(lender: CaseLender) {
    return !lender.isDeleted && (lender.caseLenderState === 2 || lender.caseLenderState === 10  || lender.caseLenderState === 5);
  }

  showAndHideExport() {
    this.showExport = !this.showExport;
  }

  getSelectedCaseLenders() {
    const selectedCaseLenders = this.caseLenders.filter((lender) => this.selectedLenders[lender.id]);
    return selectedCaseLenders;
  }

  areLendersSelected() {
    for (var lenderId in this.selectedLenders) {
      if (this.selectedLenders[lenderId]) {
        return true;
      }
    }
    return false;
  }

  dipRecieved() {
    this.showExportButton = this.caseLenders.some(
      (lender) => lender.caseLenderState === 2 || lender.caseLenderState === 10 || lender.caseLenderState === 5,
    );
  }

  logPdfDownload() {
    this.eventLogClient.logEvent(
      "EXPORTDIPPDFCLICKED",
      EventLogEnum.Export,
      ProductTypeEnum.Development,
      this.$routeParams.caseId,
    );
  }

  trustedHtml(plainText) {
    return this.$sce.trustAsHtml(plainText);
  }

  getBrokerAdminEmail(org: Organisation) {
    if (this.emailCache && this.emailCache[org.id]) {
      return;
    }

    if (!org.preferredPackagerEmail) {
      this.odataHelper
        .getOne(this.applicationUserCrudClient, {
          filter: {
            and: [{ organisationId: { eq: org.id } }, { isOrganisationAdmin: { eq: true } }],
          },
          select: {
            email: true,
          },
        })
        .then((res) => {
          this.emailCache[org.id] = res;
        });
    } else {
      this.emailCache[org.id] = org.preferredPackagerEmail;
    }
  }

  showApplyButton(lender) {
    if (
      (this.hasBidAccepted == false || this.hasBidAccepted == null) &&
      (lender.caseLenderState == CaseLenderStateEnum.Offered || lender.caseLenderState == CaseLenderStateEnum.Cancelled)
    ) {
      return true;
    }

    return false;
  }

  showCancelApplicationButton(lender) {
    if (lender.isBidAccepted == true && lender.caseLenderState == CaseLenderStateEnum.Applied) {
      return true;
    }
    return false;
  }

  // We need this as deal and case shares the same view.
  showSendToPackagerButton(lender) {
    return false;
  }
}
